// extracted by mini-css-extract-plugin
export default {"section__container":"section_section__container__34Bvb","left_dummy_div":"section_left_dummy_div__t9B2j"};